import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { z } from "zod"

import { ProductTestsContainer } from "@/screens/Products/components/Product/Quality/TestResults/components/ProductTestsContainer"

const SearchParamsValidator = z.object({
  query: z.string().optional(),
})

export const PRODUCT_TEST_RESULTS_ROUTE_LAYOUT_PATH = "/app/product/$productId/edit/_layout/quality/_layout/results"
export const PRODUCT_TEST_RESULTS_ROUTE_PATH = "/app/product/$productId/edit/quality/results"

export const Route = createFileRoute(PRODUCT_TEST_RESULTS_ROUTE_LAYOUT_PATH)({
  component: RouteComponent,
  validateSearch: SearchParamsValidator,
  search: {
    middlewares: [retainSearchParams(["query"])],
  },
})

function RouteComponent() {
  return <ProductTestsContainer />
}
